import { IonLabel } from '@ionic/react'

import type { Children } from '../../types'

function MenuLabel({ children }: Children) {
  return <IonLabel className="uppercase">{children}</IonLabel>
}

export { MenuLabel }
